import React, { useContext } from 'react';

import { Navigate } from 'react-router';

import LoadingFullScreen from '../../shared/components/Globals/LoadingFullScreen/LoadingFullScreen';
import { LOGIN_ROUTE } from '../../shared/constants/auth';
import { AuthContext } from '../../shared/hooks/useAuth/useAuth';

interface IPrivateRoute {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: IPrivateRoute) => {
  const { isLoggedIn } = useContext(AuthContext);

  if (isLoggedIn === null) {
    return <LoadingFullScreen show={true} />;
  }

  if (isLoggedIn) {
    return children;
  }

  return <Navigate to={LOGIN_ROUTE} replace />;
};

export default PrivateRoute;
